import React from 'react';

import E9FreqUseMenu from '../ecology9/E9FreqUseMenu';

class E8FreqUseMenu extends React.Component {
  render() {
    return (
      <div className="e8header-freq-use-menu">
        <E9FreqUseMenu ecId={`${(this && this.props && this.props.ecId) || ''}_E9FreqUseMenu@4e7qya`} />
      </div>
    );
  }
}

export default E8FreqUseMenu;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8FreqUseMenu.js